import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { FormattedMessage, injectIntl } from 'react-intl';

import Form from '@quintoandar/cozy-core/Form';
import Box from '@quintoandar/cozy-core/Box';
import Field from '@quintoandar/cozy-core/Field';
import Typography from '@quintoandar/cozy-core/Typography';
import Input from '@quintoandar/cozy-core/Input/Input';
import Select from '@quintoandar/cozy-core/Select';
import PhoneInput from '@quintoandar/cozy-core/experimental/PhoneInput';

import { SECTIONS } from '../constants';
import { CONTACTS_ITEMS } from './constants';
import messages from './messages';

export const onChangeComponent = ({ key, contacts, onChangeItem }) => (event, phoneProps) => {
  const contactsItems = contacts.items;
  let value = event.target.value;
  if (key === CONTACTS_ITEMS.PHONE_NUMBER) {
    value = phoneProps.internationalPhoneNumber;
  }
  const onChangeParams = {
    section: SECTIONS.CONTACTS,
    itemSlug: key,
    value,
    contactsItems: {
      ...contactsItems,
      [key]: {
        value,
      },
    },
    previousValue: contacts.items[key].value,
  };
  return onChangeItem(onChangeParams);
};

export const Contacts = ({ onChangeItem, contacts, intl }) => {
  const itemsSelectDropdown = [
    { label: intl.formatMessage(messages.porteiro), value: 'Porteiro' },
    { label: intl.formatMessage(messages.sindico), value: 'Sindico' },
    {
      label: intl.formatMessage(messages.administradora),
      value: 'Administradora',
    },
  ];

  return (
    <Fragment>
      <Box display={'flex'} alignItems={'center'}>
        <Box my={2} mr={1}>
          <Typography level="title">
            <FormattedMessage {...messages.title} />
          </Typography>
        </Box>
        <Box my={3}>
          <Typography level="caption" kind="lighter">
            <FormattedMessage {...messages.optional} />
          </Typography>
        </Box>
      </Box>
      <ValidatorForm>
        <Box mb={3}>
          <Field label={messages.type}>
            <Select
              fullWidth
              items={itemsSelectDropdown}
              placeholder={intl.formatMessage(messages.selectPlaceholder)}
              value={contacts.items.type.value}
              onChange={onChangeComponent({
                key: CONTACTS_ITEMS.TYPE,
                contacts,
                onChangeItem,
              })}
            />
          </Field>
        </Box>
        <Box my={3}>
          <Field label={messages.name}>
            <Input
              value={contacts.items.name.value}
              onChange={onChangeComponent({
                key: CONTACTS_ITEMS.NAME,
                contacts,
                onChangeItem,
              })}
              fullWidth
            />
          </Field>
        </Box>
        <Box my={3}>
          <Form>
            <Field label={messages.phoneNumber}>
              <PhoneInput
                id="external_area_contact_phone"
                name="external_area_contact_phone"
                initialValue={`${contacts.items.phoneNumber.value}`}
                onBlur={onChangeComponent({
                  key: CONTACTS_ITEMS.PHONE_NUMBER,
                  contacts,
                  onChangeItem,
                })}
              />
            </Field>
          </Form>
        </Box>
      </ValidatorForm>
    </Fragment>
  );
};
Contacts.propTypes = {
  contacts: PropTypes.object,
  onChangeItem: PropTypes.func,
  intl: PropTypes.object,
};

export default injectIntl(Contacts);
